import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { AcceptInvitationPage } from '@/features/invitations/accept-page';

const searchSchema = z.object({
  token: z.string().optional().catch(undefined),
});

/** Public: invitation links arrive by email/SMS before the person is signed in. */
export const Route = createFileRoute('/invitations/accept')({
  validateSearch: searchSchema,
  component: AcceptRoute,
});

function AcceptRoute() {
  const { token } = Route.useSearch();
  return <AcceptInvitationPage token={token} />;
}
